import { Logger } from '@sitecore-search/common';
import { getServiceConfig } from '../config.js';
/**
 * Sitecore Search Token Handler specification.
 */
const SitecoreTokenHandler = {
    async getAuthHeader() {
        const { apiKey } = getServiceConfig();
        return Promise.resolve(apiKey);
    },
};
const OrderCloudTokenHandler = {
    async getAuthHeader() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return import('ordercloud-javascript-sdk')
            .then((module) => module.Tokens)
            .then((tokens) => {
            const userToken = tokens?.GetIdentityToken();
            if (!userToken) {
                Logger.error('Could not found an Order Cloud Cloud logged user.');
                throw new Error('Could not found an Order Cloud Cloud logged user.');
            }
            Logger.info('Using existing Order Cloud Token.');
            return `Bearer ${userToken}`;
        })
            .catch((err) => {
            Logger.error('Could not import Ordercloud SDK.', err);
            throw new Error('Could not import Ordercloud SDK.');
        });
    },
};
/**
 * Gets the access token depending on which connector are we using (default as sitecore and oc (order cloud)).
 * Each property returns the same kind of object that checkToken is expecting.
 */
const TokenHandler = {
    sitecore: SitecoreTokenHandler,
    oc: OrderCloudTokenHandler,
};
export const getAPIHeaders = async () => {
    const { connector = 'oc' } = getServiceConfig();
    const headers = {
        'Content-Type': 'application/json',
    };
    return { ...headers, Authorization: (await TokenHandler[connector].getAuthHeader()) || '' };
};
